<app-invest-select [selectedInvest]="invest" (projectsChanged)="onProjectsListChanged($event)"></app-invest-select>

<table>
    <thead>
        <tr>
            <th class="project-name">
                {{ 'invest.datatables.project.shortLabel' | translate }}
                <app-tooltip text="{{'invest.datatables.project.summary' | translate}}"></app-tooltip>
            </th>
            <th class="project-year">
                {{ 'invest.datatables.year.shortLabel' | translate }}
                <app-tooltip text="{{'invest.datatables.year.summary' | translate}}"></app-tooltip>
            </th>
            <th>
                {{ 'invest.datatables.loaning.shortLabel' | translate }}
                <app-tooltip text="{{'invest.datatables.loaning.summary' | translate}}"></app-tooltip>
            </th>
            <th>
                {{ 'invest.datatables.duration.shortLabel' | translate }}
                <app-tooltip text="{{'invest.datatables.duration.summary' | translate}}"></app-tooltip>
            </th>
            <th>
                {{ 'invest.datatables.rate.shortLabel' | translate }}
                <app-tooltip text="{{'invest.datatables.rate.summary' | translate}}"></app-tooltip>
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let project of invest.projects; index as pi">
            <tr *ngFor="let year of project.years; index as i">
                <!-- Project Name -->
                <td *ngIf="i === 0" [attr.rowspan]="project.years.length + 1" class="project-name">
                    <mat-form-field class="name">
                        <input matInput appAutofocus type="text" [(ngModel)]="project.name" onclick="this.select()">
                    </mat-form-field>
                    <button type="button" mat-icon-button color="accent" (click)="onRemoveProject(pi)">
                        <mat-icon aria-label="Add">clear</mat-icon>
                    </button>
                </td>
                <!-- Year select -->
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="year.year" (selectionChange)="onLoaningTypeChanged(year)">
                            <mat-option *ngFor="let option of years" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button type="button" mat-icon-button color="accent" (click)="onRemoveYear(project, i)">
                        <mat-icon aria-label="Add">clear</mat-icon>
                    </button>
                </td>
                <!-- Loaning Amount -->
                <td>
                    <app-invest-input [isError]="checkError(year)" [value]="year.loaningAmount"
                        (valueChanged)="onValueChanged($event, year, 'loaningAmount')"></app-invest-input>
                </td>
                <!-- Loaning Duration Select -->
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="year.loaningTypeCode"
                            [disabled]="year.loaningAmount === 0 || year.year == null"
                            (selectionChange)="onLoaningTypeChanged(year)">
                            <mat-option *ngFor="let option of rateCurve" [value]="option.code">
                                {{ option.text.shortLabel }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <!-- Applied rate -->
                <td>
                    <app-invest-input *ngIf="year.loaningAmount !== 0  && year.year != null"
                        [isError]="checkError(year)" [value]="year.rate?.value" [mode]="indiceMode.percent"
                        (valueChanged)="onValueChanged($event, year, 'rate')"></app-invest-input>
                </td>
            </tr>
            <tr>
                <td colspan="4" class="alone">
                    <button type="button" mat-icon-button color="accent" (click)="onAddYear(project)">
                        <mat-icon aria-label="Add" [matTooltip]="'invest.projects.addYear.shortLabel' | translate">add
                        </mat-icon>
                    </button>
                </td>
            </tr>
        </ng-container>
        <tr>
            <td colspan="5" class="project-add">
                <button mat-icon-button color="accent" class="add-btn" (click)="onAddProject()">
                    <mat-icon aria-label="Add" [matTooltip]="'invest.projects.addProject.shortLabel' | translate">add
                    </mat-icon>
                </button>
            </td>
        </tr>
    </tbody>
</table>
